import { EventEmitter } from "@angular/core";

export class HeaderCustRight {
    id: number;
    name: string;
    label: string;
    desc: string;
    visibility: any;
    listVisibility: any[];
    userListUsed: any[];
    groupListUsed: any[];
    typeitem: boolean;

    notifyParent: EventEmitter<any> = new EventEmitter(); 

    public Clear() {
        this.id = 0;
        this.name = '';
        this.label = '';
        this.desc = '';
        this.visibility = null;
        this.listVisibility = [];
        this.userListUsed = [];
        this.groupListUsed = [];
        this.typeitem = false;
    }
    public loadVisibility(atype, avisibility) {
        for (let i = 0; i < avisibility.length; i++) {
            this.listVisibility.push({
                label: avisibility[i].name,
                value: { id: avisibility[i].id, name: avisibility[i].name },
            });
        }
    }

    public load(adata){
        this.id = adata.id;
        this.name = adata.name;
        this.label = adata.label;
        this.desc = adata.description;
        this.visibility = adata.visibility;
        this.typeitem = adata.typeitem;
        if (this.visibility === 1) {
            this.groupListUsed = [...this.getAccessList(adata)];
        }
        if (this.visibility === 2) {
            this.userListUsed = [...this.getAccessList(adata)];
        }
        this.notifyParent.emit();
    }  

    private getAccessList(adata) {
        let wAccessList = [];
        if (adata.webCustmenuVisibilities.length > 0) {
            for (let i = 0; i < adata.webCustmenuVisibilities.length; i++) {
                wAccessList.push(adata.webCustmenuVisibilities[i].name);
            }
        }
        return wAccessList;
    }
}
